export type Section = {
  id: number;
  name: string;
  description: string | null;
  classification: string | null;
  tag_id: number | null;
};

export const sections: Section[] = [
  {
    id: 41,
    name: "Ags & Softs",
    description: "Agriculture & Softs Commodities",
    classification: null,
    tag_id: 205462,
  },
  {
    id: 31,
    name: "Asian Equities",
    description: "News from large Asian equities",
    classification: "Equities",
    tag_id: 205454,
  },
  {
    id: 36,
    name: "Asian News",
    description: null,
    classification: null,
    tag_id: 205459,
  },
  {
    id: 39,
    name: "Bank Research",
    description: null,
    classification: "Central Banks",
    tag_id: 205460,
  },
  {
    id: 38,
    name: "Brexit",
    description: "Brexit",
    classification: null,
    tag_id: 195832,
  },
  {
    id: 10,
    name: "BoC",
    description: "Data, news and speakers from the Bank of Canada",
    classification: "Central Banks",
    tag_id: 194880,
  },
  {
    id: 16,
    name: "BoE",
    description: "Data, news and speakers from the Bank of England",
    classification: "Central Banks",
    tag_id: 194879,
  },
  {
    id: 14,
    name: "BoJ",
    description: "Data, news and speakers from the Bank of Japan",
    classification: "Central Banks",
    tag_id: 194881,
  },
  {
    id: 2,
    name: "CAC",
    description: "CAC 40 news",
    classification: "Equities",
    tag_id: 205437,
  },
  {
    id: 9,
    name: "Canadian Data",
    description: "Economic data from Canada",
    classification: "Economic Releases",
    tag_id: 205444,
  },
  {
    id: 42,
    name: "Crypto",
    description: "Major Cryptocurrencies",
    classification: null,
    tag_id: 205463,
  },
  {
    id: 1,
    name: "DAX",
    description: "DAX news",
    classification: "Equities",
    tag_id: 198080,
  },
  {
    id: 27,
    name: "Economic Commentary",
    description: "Commentary on the global macro economy",
    classification: null,
    tag_id: 195267,
  },
  {
    id: 17,
    name: "ECB",
    description: "Data, news and speakers from the European Central Bank",
    classification: "Central Banks",
    tag_id: 194882,
  },
  {
    id: 43,
    name: "Emerging Markets",
    description: "Typically Covers BRICS related news",
    classification: null,
    tag_id: 205464,
  },
  {
    id: 20,
    name: "Energy & Power",
    description: "News flow related to commodities",
    classification: null,
    tag_id: 205446,
  },
  {
    id: 6,
    name: "EU Data",
    description: "Economic data from major European countries",
    classification: "Economic Releases",
    tag_id: 205441,
  },
  {
    id: 33,
    name: "European Equities",
    description: "News from smaller European listed equities",
    classification: "Equities",
    tag_id: 205456,
  },
  {
    id: 28,
    name: "EUROSTOXX",
    description: "Eurostoxx 50 news",
    classification: "Equities",
    tag_id: 205451,
  },
  {
    id: 18,
    name: "Fed",
    description: "Data, news and speakers from the Federal Reserve",
    classification: "Central Banks",
    tag_id: 195292,
  },
  {
    id: 21,
    name: "Fixed Income",
    description: "Fixed income flows, options and news",
    classification: null,
    tag_id: 195275,
  },
  {
    id: 32,
    name: "FTSE 100",
    description: "FTSE 100 news",
    classification: "Equities",
    tag_id: 205455,
  },
  {
    id: 22,
    name: "FX Flows",
    description: "FX flows, options and news",
    classification: null,
    tag_id: 205447,
  },
  {
    id: 23,
    name: "Geopolitical",
    description: "News related to global geopolitical events",
    classification: null,
    tag_id: 195270,
  },
  {
    id: 34,
    name: "Global Equities",
    description: "News from large sized global equities",
    classification: "Equities",
    tag_id: 205457,
  },
  {
    id: 25,
    name: "Global News",
    description: "Global news (often related to natural catastrophes)",
    classification: null,
    tag_id: 205449,
  },
  {
    id: 37,
    name: "Metals",
    description: null,
    classification: null,
    tag_id: 195278,
  },
  {
    id: 7,
    name: "Market Analysis",
    description: "General news or commentary on market moves",
    classification: null,
    tag_id: 205442,
  },
  {
    id: 26,
    name: "Newsquawk Update",
    description: "Newsystem updates, notifications or market notices",
    classification: "Newsquawk Update",
    tag_id: 205450,
  },
  {
    id: 8,
    name: "Other Central Banks",
    description: "Data, news and speakers from other important central banks",
    classification: "Central Banks",
    tag_id: 205443,
  },
  {
    id: 19,
    name: "Other Data",
    description: "Economic data from Asia and other countries",
    classification: "Economic Releases",
    tag_id: 205445,
  },
  {
    id: 15,
    name: "PBoC",
    description: "Data, news and speakers from the People's Bank of China",
    classification: "Central Banks",
    tag_id: 194883,
  },
  {
    id: 12,
    name: "RBA",
    description: "Data, news and speakers from the Reserve Bank of Australia",
    classification: "Central Banks",
    tag_id: 194884,
  },
  {
    id: 11,
    name: "RBNZ",
    description: "Data, news and speakers from the Reserve Bank of New Zealand",
    classification: "Central Banks",
    tag_id: 194886,
  },
  {
    id: 24,
    name: "Rating Agency comments",
    description: "Comments from S&P, Moody's and Fitch",
    classification: null,
    tag_id: 205448,
  },
  {
    id: 13,
    name: "SNB",
    description: "Data, news and speakers from the Swiss National Bank",
    classification: "Central Banks",
    tag_id: 194888,
  },
  {
    id: 3,
    name: "SMI",
    description: "SMI news",
    classification: "Equities",
    tag_id: 205438,
  },
  {
    id: 5,
    name: "Swiss Data",
    description: "Economic data from Switzerland",
    classification: "Economic Releases",
    tag_id: 205440,
  },
  {
    id: 29,
    name: "UK Data",
    description: "Economic data from the United Kingdom",
    classification: "Economic Releases",
    tag_id: 205452,
  },
  {
    id: 35,
    name: "UK Equities",
    description: "News from smaller sized UK equities",
    classification: "Equities",
    tag_id: 205458,
  },
  {
    id: 4,
    name: "US Data",
    description: "Economic data from the United States of America",
    classification: "Economic Releases",
    tag_id: 205439,
  },
  {
    id: 30,
    name: "US Equities",
    description: "US Equity News",
    classification: "Equities",
    tag_id: 205453,
  },
  {
    id: 44,
    name: "US Equity Plus",
    description: "US Equity Plus",
    classification: "Equities",
    tag_id: 205465,
  },
  {
    id: 40,
    name: "US Election",
    description: "2020 US Election News",
    classification: null,
    tag_id: 205461,
  },
];
